// extracted by mini-css-extract-plugin
module.exports = {"drawer-root":"main-view-layout_drawer-root__Xw7Cg"};